<template>
    <div>
        <b-input-group>
            <b-form-input
                id="price-change-since"
                v-model="input.manufacturerInput"
                type="text"
                placeholder="Hersteller"
                @keydown="showSelected = false"
            />
            <b-input-group-append>
                <b-btn variant="outline-success">Suche</b-btn>
            </b-input-group-append>
        </b-input-group>
        <div v-if="filteredList.length > 0" id="manufacturer-result-box">
            <div
                v-for="(manufacturer, index) in filteredList"
                :key="index"
                class="manufacturer"
                :class="{ selected: manufacturer.selected }"
                @click="selectManufacturer(manufacturer)"
            >
                <span>{{ manufacturer.number }}</span>
                {{ manufacturer.name }}
            </div>
        </div>
        <div v-else id="manufacturer-empty-result">
            Kein Hersteller gefunden.
            <br />
            Bitte passen Sie Ihre Suche an.
        </div>
        <div id="manufacturer-selection-info">
            <span
                v-if="showSelected"
                id="manufacturer-selection-showAll"
                @click="showSelected = false"
            >
                zurück zur Vollansicht
            </span>
            <span v-else>{{ filteredList.length }} angezeigte Hersteller</span>

            <span id="manufacturer-selection-interaction" @click="showSelectedManufacturer">
                <span id="manufacturer-highlight">
                    {{ selectedManufacturer.length }}
                </span>
                ausgewählt
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "SelectManufacturer",
    props: {
        value: {
            default: () => [],
            type: [Array, Number]
        },
        singleSelect: {
            type: Boolean,
            default: function() {
                return false;
            }
        }
    },
    data() {
        return {
            showSelected: false,
            input: {
                manufacturerInput: null
            }
        };
    },
    computed: {
        manufacturerList() {
            return this.$store.state.data.manufacturer;
        },
        filteredList() {
            // eslint-disable-next-line no-unused-vars
            const detectChange = this.forceUpdateHelper;
            // temp: item.name !== "" so non-empty
            let filteredList = this.manufacturerList.filter(item => item.name && item.name !== "");
            if (!this.input.manufacturerInput) {
                return filteredList.filter(
                    manufacturer =>
                        // only show selected items when activated;
                        !this.showSelected || (this.showSelected && manufacturer.selected)
                );
            }

            return filteredList.filter(
                manufacturer =>
                    manufacturer.name
                        .toLowerCase()
                        .indexOf(this.input.manufacturerInput.toLowerCase()) > -1 ||
                    (manufacturer.number + "").startsWith(this.input.manufacturerInput)
            );
        },
        selectedManufacturer() {
            // eslint-disable-next-line no-unused-vars
            const detectChange = this.forceUpdateHelper;
            return this.manufacturerList.filter(item => item.selected === true);
        }
    },
    created() {
        this.setPresets();
    },
    methods: {
        setPresets() {
            if (Array.isArray(this.value)) {
                this.manufacturerList
                    .filter(item => this.value.includes(item.id))
                    .forEach(manufacturer => this.selectManufacturer(manufacturer));
            } else {
                if (!this.value) {
                    this.manufacturerList.forEach(
                        manufacturer => this.$set(manufacturer, "selected", false),
                        this
                    );
                } else {
                    this.manufacturerList
                        .filter(target => target.id === this.value)
                        .forEach(manufacturer => {
                            console.log(manufacturer);
                            this.selectManufacturer(manufacturer);
                        }, this);
                }
            }
        },
        showSelectedManufacturer() {
            if (this.selectedManufacturer.length > 0) {
                this.showSelected = !this.showSelected;
            }
        },
        selectManufacturer(manufacturer) {
            if (this.singleSelect) {
                let that = this;
                this.manufacturerList
                    .filter(target => target !== manufacturer)
                    .forEach(manufacturer => {
                        that.$set(manufacturer, "selected", false);
                    });
            }

            this.$set(
                manufacturer,
                "selected",
                typeof manufacturer.selected === typeof undefined ? true : !manufacturer.selected
            );
            // vue mixin
            this.forceUpdate();
            const list = this.selectedManufacturer;

            if (list.length === 0) {
                this.showSelected = false;
            }

            if (this.singleSelect) {
                this.$emit("input", list.map(item => item.id)[0]);
            } else {
                this.$emit(
                    "input",
                    list.map(item => item.id)
                );
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#manufacturer-result-box,
#manufacturer-empty-result {
    overflow-y: auto;
    height: 148px;
}

#manufacturer-selection-info {
    display: flex;
    justify-content: space-between;
    padding: 4px 8px;
    color: $gray-light;
}

#manufacturer-highlight {
    color: $black;
}
#manufacturer-selection-showAll {
    cursor: pointer;
    text-decoration: underline dotted $green;
}
#manufacturer-selection-showAll:hover {
    text-decoration: underline solid $green;
}

#manufacturer-result-box,
#manufacturer-selection-info,
#manufacturer-empty-result {
    margin: 5px 0px;
    border-radius: 4px;
    overflow-x: hidden;
    border: 1px solid #ced4da;
}

#manufacturer-empty-result {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 12px;
}

#manufacturer-selection-interaction {
    cursor: pointer;
}
.manufacturer {
    cursor: pointer;
    padding: 3px 5px;
}
.manufacturer:not(:last-of-type) {
    border-bottom: 1px solid $gray-light;
}
.manufacturer:hover {
    background: $gray-lighter;
}

.manufacturer.selected {
    background: $green;
}

.manufacturer.selected:hover {
    background: darken($green, 10%);
}
</style>
